import React from 'react'
import ReactDOM from 'react-dom'

function maybeAddClass(classList, className) {
  if (className) {
    classList.add(...className.split(' '))
  }
}

export const Portal = ({ children, container, className }) => {
  const [hasMounted, setMounted] = React.useState(false)
  const [portalElement, setPortalElement] = React.useState(null)

  const createContainerElement = React.useCallback(() => {
    const container = document.createElement('div')
    maybeAddClass(container.classList, className)

    return container
  }, [className])

  React.useEffect(() => {
    if (hasMounted && portalElement) return
    const el = createContainerElement()
    if (container) {
      container.appendChild(el)
    } else {
      document.body.appendChild(el)
    }
    setPortalElement(el)
    setMounted(true)
  }, [
    container,
    hasMounted,
    portalElement,
    setPortalElement,
    setMounted,
    createContainerElement
  ])

  if (typeof document === 'undefined' || !hasMounted || portalElement === null)
    return null

  return ReactDOM.createPortal(children, portalElement)
}
